import { getSupabase } from './supabase.js';

// Subscribes to postgres_changes on games and seats, filtered by game id.
// Returns a `stop` function. Callbacks are invoked on every UPDATE/INSERT.

export function subscribeGame(gameId, { onGame, onSeats }) {
  const db = getSupabase();
  const channel = db
    .channel(`game:${gameId}`)
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'games', filter: `id=eq.${gameId}` },
      (payload) => {
        if (onGame) onGame(payload.new);
      },
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'seats', filter: `game_id=eq.${gameId}` },
      (payload) => {
        if (onSeats) onSeats(payload);
      },
    )
    .subscribe();

  return () => {
    db.removeChannel(channel);
  };
}
